var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyStateUniform(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 113,
    viewBox: "0 0 112 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1H104C108.142 1 111.5 4.35787 111.5 8.5V104.5C111.5 108.642 108.142 112 104 112H8C3.85787 112 0.5 108.642 0.5 104.5V8.5C0.5 4.35787 3.85787 1 8 1Z",
    fill: "#EEF6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2665 18.4993C45.0712 23.7298 50.0868 27.4993 56.0005 27.4993C61.9142 27.4993 66.9305 23.7298 68.7345 18.4993H43.2665ZM84.1295 55.1443V87.4993C84.1295 92.4759 80.0787 96.4993 75.0904 96.4993H36.9104C31.9221 96.4993 27.8713 92.4759 27.8713 87.4993V55.1443L20.9455 52.0115C18.4807 50.8982 17.3439 48.0349 18.3869 45.5427L27.3283 24.0977C27.8244 22.9063 28.7619 21.9571 29.9455 21.4375L40.2545 16.9219C40.8912 16.6445 41.5826 16.5 42.2779 16.5H69.7229C70.4182 16.5 71.1096 16.6445 71.7463 16.9219L82.0553 21.4375C83.2389 21.957 84.1764 22.9063 84.6725 24.0977L93.6139 45.5427C94.6569 48.0349 93.5201 50.8982 91.0553 52.0115L84.1295 55.1443Z",
    fill: "#A0C8FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateUniform);
export default __webpack_public_path__ + "static/media/empty-state-uniform.d833b4bf.svg";
export { ForwardRef as ReactComponent };